// API configuration for CRM
// Use environment variable for production, fallback to localhost for development
const API_URL = import.meta.env.VITE_API_URL || '';

export async function fetchWithAuth(url: string, options: RequestInit = {}, token: string | null) {
  if (!token) {
    throw new Error('Not authenticated');
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
    ...options.headers,
  };

  const response = await fetch(`${API_URL}${url}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }

  return response.json();
}

export function getApiUrl(): string {
  return API_URL;
}

// Alias for compatibility
export function getApiBaseUrl(): string {
  return API_URL;
}

export { API_URL };
